<template>
  <div class="incidents pad">

    <div>
      <router-link to="/incidents/add" class="button is-warning is-large"><fa icon="exclamation-triangle" />&nbsp;report an incident</router-link>
    </div>

    <loading v-if="items === null" />

    <b-message v-if="items && !items.length" class="margin-top-20">No incidents</b-message>

    <table v-if="items && items.length" class="table is-striped is-hoverable is-bordered">
      <thead>
        <tr>
          <th>Status</th>
          <th>Date Of Incident</th>
          <th>Reported By</th>
          <th>Date Reported</th>
          <th>Type Of Incident</th>
          <th>Nature Of Incident</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item._id" @click="$router.push(`/incident/${item._id}`)">
          <td class="ud">{{ item.status | unCamel}}</td>
          <td>{{ item.details.dateOfIncident | unixToDateTimeString }}</td>
          <td>{{ item.details.name }}</td>
          <td>{{ item.timestampCreated | unixToDateTimeString }}</td>
          <td>{{ item.details.type }}</td>
          <td>{{ item.details.natureOfIncident }}</td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
export default {
  data () {
    return {
      items: null
    }
  },
  computed: {
    user () { return this.$store.getters.user }
  },
  created () {
    this.subs.incidents = this.$fs.collection('incidents')
      .where(`userId`, '==', this.user._id)
      .onSnapshot(ss => {
        this.items = this.$ssToArr(ss)
      })
  }
}
</script>
